import React, { Component } from 'react';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';

import { applications } from '../../Data/applications';
import { isEmptyJSON } from '../../functions/functions';
import ItemApplication from './ItemApplication';
import ItemCategory from './ItemCategory';
import { message } from '../../translate';

class MenuApplications extends Component {

  constructor () {
    super();

    this.state = {
      categorySelect : 'all',
      _applications : [],
      _start : 0,
      _final : 12,
      pageSize : 12,
      _total : 372
    }

    this.handleCategory    = this.handleCategory.bind(this);
    this.handleApplication = this.handleApplication.bind(this);
    this.handlePagination  = this.handlePagination.bind(this);
  }

  handleCategory (evt) {
    evt.preventDefault();
    let categorySelect = evt.target.getAttribute('data-category');

    if ( categorySelect !== 'all' ) {
      const _applications = applications().filter( _apps => _apps.category === categorySelect );
      document.getElementById('btnMenu').className = 'navbar-toggler collapsed';
      document.getElementById('collapsibleNavbar').className = 'navbar-collapse collapse';
      this.setState({
        categorySelect,
        _applications,
        _total: _applications.length,
        _start : 0,
        _final : 12
      });
    } else {
      this.setState({
        categorySelect,
        _applications: null,
        _total: 372,
        _start : 0,
        _final : 12
      });
    }

  }

  handleApplication (evt) {
    evt.preventDefault();
    // Falta definir el parametro a tener en cuenta para el link (ruta)
  }

  renderApplications () {
    const { _applications, _start, _final } = this.state;
    let obj = [];

    if ( isEmptyJSON(_applications) === true ) {
      obj = _applications;
      obj = obj.slice( _start, _final );
    } else if ( isEmptyJSON(_applications) === false ) {
      obj = applications();
      obj = obj.slice( _start, _final );
    }

    return (
      obj.map( ap => {
        return (
          <ItemApplication
            key               = { ap.name }
            app_name          = { ap.name }
            app_url           = { ap.url }
            handleApplication = { this.handleApplication }
            category          = { ap.category }
          />
        )
      })
    )

  }

  handlePagination ( current, pageSize ) {

    if ( current === 1 ) {
      this.setState({
        _start: 0,
        _final: 12
      });
    } else {
      let _final = ( current * pageSize );
      let _start = (_final - 12);

      this.setState({
        _start,
        _final
      });
    }
  }

  render () {
    return (
      <div>
        <nav className="navbar bg-dark navbar-dark">
          <ItemCategory principal = { true } handleCategory = { this.handleCategory } />
          <button id="btnMenu" className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="collapsibleNavbar">
            <ul className="navbar-nav">
              <ItemCategory principal = { false } handleCategory = { this.handleCategory } />
            </ul>
          </div>
        </nav>

        <section className="jumbotron text-center">
          <div className="container">
            <h3 className="jumbotron-heading">{ message('titleApp') }</h3>
            <p className="lead text-muted">
              { message('messageApp') }
            </p>
          </div>
        </section>

        <div className="album py-5 bg-light">
          <div className="container">
            <div className="row">
               { this.renderApplications() }
            </div>
            <div className="row justify-content-center align-items-center">
             <Pagination
               defaultPageSize = { this.state.pageSize }
               showTotal={ ( total, range) =>  `${range[0]} - ${range[1]} de ${total} elementos `}
               total={ this.state._total }
               onChange = { this.handlePagination }
             />
            </div>
          </div>
        </div>

      </div>
    )
  }
}

export default MenuApplications;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuApplications.js